module.exports = __webpack_public_path__ + "99b14f0da0591e0d71678dc163eaff8b.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Regular.ttf
// module id = 344
// module chunks = 0